<template>
  <q-card style="width: 700px; max-width: 80vw;">
    <q-form @submit.prevent="addProject">
      <q-card-section>
        <div class="text-h6">Новый проект</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <q-input dense v-model="newProject.name" label="Имя проекта" :rules="[requiredRule, objectNameRule]"/>
        <q-input dense v-model="newProject.code" label="Код проекта" :rules="[requiredRule, codeRule]"/>
        <q-input dense v-model="newProject.description" type="textarea" label="Описание"/>
        <q-select dense v-model="newProject.organizationId" clearable :loading="isFetchingOrganizations"
                  :options="organizations" option-label="name" option-value="id" label="Организация" emit-value
                  behavior="menu" map-options/>
        <select-project-type v-model="newProject.typeId"/>

      </q-card-section>

      <q-card-actions align="right" class="text-primary">
        <q-btn no-caps flat label="Отмена" color="negative" @click="$emit('cancel')"/>
        <q-btn no-caps flat label="Создать" type="submit"/>
      </q-card-actions>
    </q-form>

  </q-card>
</template>

<script setup lang="ts">
import {requiredRule, codeRule, objectNameRule} from "../util/rules";
import {reactive, watch} from "vue";
import {NewProject, ProjectTypeSummary} from "../models/project";
import {useOwnedProjectTypes, useAddProject, useProjectTypesList} from "../composables/project";
import cyrillicToTranslit from "cyrillic-to-translit-js";
import {useOwnedOrganization} from "../composables/organization";
import ProjectTypeItem from "./ProjectTypeItem.vue";
import ProjectTypeSelect from "./ProjectTypeSelect.vue";
import SelectProjectType from "./SelectProjectType.vue";

const translit = cyrillicToTranslit()
const emits = defineEmits(['add', 'cancel'])

const {data: organizations, isFetching: isFetchingOrganizations} = useOwnedOrganization()

const newProject: NewProject = reactive({
  name: "",
  code: "",
  description: "",
  typeId: null,
  organizationId: null,
})

watch(() => newProject.name, (val) => {
  newProject.code = createProjectKey(val);
})

const {execute} = useAddProject(newProject)


function createProjectKey(projectName: string) {
  // Convert project name to Latin characters
  let translitName = translit.transform(projectName, " ");

  // Split the name into words
  let words = translitName.toUpperCase().replace(/[0-9.,]/ig, "").split(" ");

  let projectKey = "";

  // If there's only one word, use the first 5 characters
  if (words.length === 1) {
    projectKey = words[0].substring(0, 5);
  } else {
    // Get first two letters from the last word
    let lastWord = words[words.length - 1];
    let lastWordKey = lastWord.substring(0, Math.min(2, lastWord.length));

    // Calculate remaining characters to take from the first words
    let remainingChars = 5 - lastWordKey.length;

    // For each of the first words, add the first letter to the project key
    for (let i = 0; i < words.length - 1 && remainingChars > 0; i++) {
      if (words[i]) {
        projectKey += words[i][0];
        remainingChars--;
      }
    }

    // Add last word key to the end
    projectKey += lastWordKey;
  }

  return projectKey;
}

async function addProject() {
  await execute(true)
  emits('add')
}

</script>

<style scoped></style>